var map = {
	"./axa.png": 1046,
	"./baby-verified.png": 1051,
	"./comment.png": 1042,
	"./critical-filled.png": 1026,
	"./critical.png": 1052,
	"./cross-black-filled-mobile.png": 1053,
	"./cross-black-filled.png": 1027,
	"./cross-filled.png": 1028,
	"./cross.png": 1054,
	"./dollar.png": 1055,
	"./education-black-filled-mobile.png": 1056,
	"./education-black-filled.png": 1029,
	"./education-filled.png": 1030,
	"./focus-green-tick.png": 1057,
	"./green-tick.png": 1058,
	"./hero-dream.png": 1059,
	"./hero-education.png": 1060,
	"./hero-health.png": 1061,
	"./img-msg.png": 1043,
	"./money-black-filled-mobile.png": 1062,
	"./money-black-filled.png": 1031,
	"./money-filled.png": 1032,
	"./money.png": 1063,
	"./option-ci-filled.png": 1033,
	"./option-ci.png": 1064,
	"./option-education-funds-filled.png": 1034,
	"./option-education-funds.png": 1065,
	"./option-health-filled.png": 1035,
	"./option-health.png": 1066,
	"./option-life-filled.png": 1036,
	"./option-life.png": 1067,
	"./option-wealth-filled.png": 1037,
	"./option-wealth.png": 1068,
	"./pregnancy.png": 1069,
	"./price-tag.png": 1070,
	"./quick-guide.png": 1071,
	"./red-tick.png": 1072,
	"./tenlife-verified.png": 1041,
	"./term-life-filled.png": 1038,
	"./term-life.png": 1073,
	"./video-click-button.png": 1016
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1025;